import {
  AddOutlined,
  ArrowBackOutlined,
  Delete,
  DeleteOutline,
  EditOutlined,
  RefreshOutlined,
} from "@material-ui/icons";
import {
  Box,
  Button,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SearchIcon from "@mui/icons-material/Search";
import useToast from "../../../../../../hooks/useToast";
import useConfirm from "../../../../../../hooks/useConfirm";
import { SQCFormulaireService } from "../../../../../../service/SQC_form/SQCFormulaireService";
import SQCDialogForm from "./SQCDialogForm";
import { useQuery } from "../../../../../../hooks/useQuery";
import { TYPE_NOTIFICATION } from "../../../../shares/NotificationBull";

const SQCFormList = ({ selection = false }) => {
  const [formulaireList, setFormulaireList] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const navigate = useNavigate();
  const [filtre, setFiltre] = useState({});
  const { Toast, showToast } = useToast();
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [idSelectedForm, setIdSelectedForm] = useState(null);
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const url = useQuery();
  const id_type = url.get("ref");

  const handleShowQuestionList = (uuid) => {
    navigate(`questions?form_id=${uuid}`);
  };

  const handleGoBack = () => {
    navigate(-1);
  };
  const handleFetchFormualaireListe = () => {
    setDataLoading(true);
    SQCFormulaireService.list({ ...filtre, id_type: url.get("ref") })
      .then((res) => {
        if (res && res.data) {
          setFormulaireList(res.data);
          setFilteredRows(res.data);
        } else {
          setFormulaireList([]);
          setFilteredRows([]);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleDeleteRow = (id) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => {
        handleConfirmDeleteRow(id);
      }
    );
  };

  const handleConfirmDeleteRow = (id) => {
    SQCFormulaireService.delete(id).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchFormualaireListe();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleOpenDialogForm = (idForm) => {
    setOpenFormDialog(true);
    setIdSelectedForm(idForm);
  };

  const handleCloseDialogForm = () => {
    setOpenFormDialog(false);
    handleFetchFormualaireListe();
  };

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(formulaireList);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      formulaireList.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot)
          )
        )
      )
    );
  };

  const table_colonne = [
    {
      field: "libele",
      headerName: "Libellé formulaire",
      flex: 1,
      minWidth: 150,
    },
    {
      // field: "created_at",
      field: "categorie",
      headerName: "Type/Fonction/Catégorie",
      minWidth: 150,
    },
    {
      // field: "created_at",
      field: "created_at",
      headerName: "Date de création",
      minWidth: 150,
    },
    {
      field: "updated_at",
      headerName: "Date de modification",
      minWidth: 120,
    },
    {
      field: "direction_antenne",
      headerName: "Direction/Antenne",
      minWidth: 120,
    },
    {
      field: "region",
      headerName: "Région",
      minWidth: 120,
    },
    {
      field: "district",
      headerName: "District",
      minWidth: 120,
    },
    {
      field: "commune",
      headerName: "Commune",
      minWidth: 120,
    },
    {
      field: "zone",
      headerName: "Zone",
      minWidth: 120,
    },
    {
      field: "cadre_dirigeant",
      headerName: "Cadre dirigeant",
      minWidth: 120,
    },
    {
      field: "superviseur",
      headerName: "Superviseur",
      minWidth: 120,
    },
    {
      field: "informaticien_os",
      headerName: "Informaticien/OS",
      minWidth: 120,
    },
    {
      field: "nbr_chef_eqipe",
      headerName: "Chef d'eqipe",
      minWidth: 120,
    },
    {
      field: "redacteur",
      headerName: "Redacteur",
      minWidth: 120,
    },
    {
      field: "volontaires",
      headerName: "Volontaires",
      minWidth: 120,
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Parametrer questions"
              color="primary"
              onClick={(e) =>
                handleShowQuestionList(params.row.ext_sqc_form_id)
              }
            >
              <SettingsOutlinedIcon />
            </IconButton>
            <IconButton
              title="Modifier formulaire"
              color="secondary"
              onClick={(e) => handleOpenDialogForm(params.row.ext_sqc_form_id)}
            >
              <EditOutlined />
            </IconButton>
            <IconButton
              title="Supprimer formulaire"
              color="warning"
              onClick={(e) => handleDeleteRow(params.row.ext_sqc_form_id)}
            >
              <DeleteOutline />
            </IconButton>
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchFormualaireListe();
  }, []);

  return (
    <>
      <SQCDialogForm
        open={openFormDialog}
        idAmi={id_type}
        idForm={idSelectedForm}
        onFormClose={handleCloseDialogForm}
      />
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="Formulaires SQC"
              titleTypographyProps={{ variant: "h5" }}
              avatar={
                <Button onClick={handleGoBack}>
                  <ArrowBackOutlined />
                </Button>
              }
              action={
                <Grid container spacing={2} justifyContent="space-around">
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      onChange={(e) => handleFilter(e.target.value)}
                      placeholder="Recherche"
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      title="Actualiser"
                      color="primary"
                      onClick={handleFetchFormualaireListe}
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      onClick={(e) => handleOpenDialogForm(null)}
                      color="primary"
                      title="Creer une formulaire"
                    >
                      <AddOutlined />
                    </IconButton>
                  </Grid>
                </Grid>
              }
            />
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                // rows={formulaireList}
                rows={filteredRows}
                getRowId={(row) => row.ext_sqc_form_id}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default SQCFormList;
